import { getItem, setItem } from "@lib/storage";
import { Platform } from "react-native";
import uuid from "react-native-uuid";

const WEB_DEVICE_ID_KEY = "cm_web_device_id";

// On web both device-id native modules (react-native-device-info / @lib/idfa)
// are webpack-shimmed to noop → getUniqueId()/IDFA.getIDFA() return
// undefined/empty → the session row lands with NULL idfa/unique_device_id and
// the web login is un-backtraceable. Mint a plain UUID once per browser and
// persist it via @lib/storage (partner-db's MMKV layer, webpack-shimmed to
// localStorage on web → survives reloads) so every web session for this
// browser carries the same id. Native is untouched: the real device modules
// return real values there, so this fallback never fires.
let cached = null;

const getOrCreateWebDeviceId = async () => {
  if (cached) return cached;
  // Native already has real device ids; nothing to mint.
  if (Platform.OS !== "web") return cached;
  try {
    const existing = await getItem(WEB_DEVICE_ID_KEY);
    if (existing) {
      cached = existing;
      return cached;
    }
    const fresh = uuid.v4();
    await setItem(WEB_DEVICE_ID_KEY, fresh);
    cached = fresh;
    return cached;
  } catch {
    // Persistence failed (private mode etc.) — still return a stable id for
    // this in-memory session rather than null.
    if (!cached) cached = uuid.v4();
    return cached;
  }
};

export default getOrCreateWebDeviceId;
